<template>
    <div class="col-md-6">
        <div class="card">
            <div class="card-header pb-0">
                <h3>Pill Rating</h3>
            </div>
            <div class="card-body">
                <div class="rating-container">
                    <vue3-star-ratings v-model="rating"></vue3-star-ratings>
                    <pre class="mb-0 rating-pre">Rating {{ rating }}</pre>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            rating: "0",
            disabled: false
        }
    },
    methods: {
        currentRatingText() {

        }
    }
}
</script>